// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"f2de0d7d","563":"31d6cfe0","994":"31d6cfe0"}[chunkId] + ".chunk.css";
};